const projectData = [
  {
    title: 'soul serenity',
    caption: 'Journal App',
    description: 'Where thoughts bloom to the rhythm of keystrokes, wrapped in soundscapes and softly animated skies.',
    year: '2024',
    projectUrl: 'https://soul-serenity-journal-app.vercel.app/',
    thumbnail_video: '/videos/Soul Serenity.mp4',
    thumbnail_image: '/projects/soul_serenity/soul serenity (2).png',
    images: [
      '/projects/soul_serenity/soul serenity (2).png',
      '/projects/soul_serenity/soul serenity (4).png',
      '/projects/soul_serenity/soul serenity (3).png',
      '/projects/soul_serenity/soul serenity (1).png',
      '/projects/soul_serenity/soul serenity (5).png',
    ],
    tech: ['MongoDB', 'Express', 'React', 'Node', 'Auth0', 'Figma'],
  },
  {
    title: 'celestial tarot',
    caption: 'AI Tarot Platform',
    description: 'A modern tarot reading experience powered by AI, with animated cards and personalized cosmic insights.',
    year: '2024',
    projectUrl: 'https://celestial-tarot-2-0.vercel.app/',
    thumbnail_video: '/videos/Celestial Tarot 2.0.mp4',
    thumbnail_image: '/projects/celestial_tarot/celestial tarot (4).png',
    images: [
      '/projects/celestial_tarot/celestial tarot (4).png',
      '/projects/celestial_tarot/celestial tarot (3).png',
      '/projects/celestial_tarot/celestial tarot (2).png',
      '/projects/celestial_tarot/celestial tarot (5).png',
      '/projects/celestial_tarot/celestial tarot (1).png',
      '/projects/celestial_tarot/celestial tarot (6).png',
      '/projects/celestial_tarot/celestial tarot (7).png',
    ],
    tech: ['React', 'HTML', 'CSS', 'Figma', 'OpenAI API', 'Firebase', 'MongoDB', 'Express', 'Node'],
    inspiration: 'Unseen Studio',
    inspiration_url: 'https://www.awwwards.com/unseenstudio/'
  },
  {
    title: 'glimmering grove',
    caption: 'Ecommerce',
    description: 'An enchanted ecommerce experience for nature-inspired goods, blending fantasy design with modern shopping.',
    year: '2024',
    projectUrl: 'https://jackie3668.github.io/glimmering-grove/',
    thumbnail_video: '/videos/Glimmering Grove.mp4',
    thumbnail_image: '/projects/glimmering_grove/Preview-1.png',
    images: [
      '/projects/glimmering_grove/Preview-1.png',
      '/projects/glimmering_grove/Preview-2.png',
      '/projects/glimmering_grove/Preview-3.png',
      '/projects/glimmering_grove/Preview-4.png',
      '/projects/glimmering_grove/Preview-5.png',
      '/projects/glimmering_grove/Preview-6.png',
      '/projects/glimmering_grove/Preview-7.png',
      '/projects/glimmering_grove/preview.png',
      '/projects/glimmering_grove/preview1.jpg',
      '/projects/glimmering_grove/preview2.jpg',
    ],
    tech: ['React', 'HTML', 'CSS', 'Figma'],
    inspiration: 'Template Twist Shop',
    inspiration_url: 'https://creativemarket.com/Templatesxox'
  },
  {
    title: 'fresh mint',
    caption: 'Meal Kit Website',
    description: 'A refreshing website for weekly meal kits, with smooth flows, ingredient guides, and a minty-fresh UX.',
    year: '2024',
    projectUrl: 'https://jackie3668.github.io/fresh-mint/',
    thumbnail_video: '/videos/Fresh Mint.mp4',
    thumbnail_image: '/images/thumbnails/fresh-mint.jpg',
    images: [
      '/projects/fresh_mint/Background-1.png',
      '/projects/fresh_mint/Background-2.png',
      '/projects/fresh_mint/Background-3.png',
      '/projects/fresh_mint/Background-4.png',
      '/projects/fresh_mint/Background.png',
    ],
    tech: ['React', 'HTML', 'CSS', 'Figma'],
  },
  {
    title: 'mentor a promise',
    caption: 'Nonprofit Platform',
    description: 'A nonprofit network matching youth with mentors, built with accessibility, clarity, and purpose.',
    year: '2024',
    projectUrl: 'https://mentorapromise.org/',
    thumbnail_video: '/videos/Mentor A Promise.mp4',
    thumbnail_image: '/projects/mentor_a_promise/map (2).png',
    images: [
      '/projects/mentor_a_promise/map (2).png',
      '/projects/mentor_a_promise/map (1).png',
      '/projects/mentor_a_promise/map (3).png',
      '/projects/mentor_a_promise/map (5).png',
      '/projects/mentor_a_promise/map (4).png',
    ],
    tech: ['React', 'HTML', 'CSS', 'Figma'],  },
  {
    title: 'portfolio',
    caption: 'Portfolio',
    description: 'An experimental digital portfolio crafted with motion, storytelling, and subtle interactivity at its core.',
    year: '2024',
    projectUrl: 'https://portfolio-2024-omega-murex.vercel.app/',
    thumbnail_video: '/videos/Portfolio 2024.mp4',
    thumbnail_image: '/projects/portfolio_2024/portfolio (2).png',
    images: [
      '/projects/portfolio_2024/portfolio (2).png',
      '/projects/portfolio_2024/portfolio (4).png',
      '/projects/portfolio_2024/portfolio (5).png',
      '/projects/portfolio_2024/portfolio (3).png',
      '/projects/portfolio_2024/portfolio (1).png',

    ],
    tech: ['React', 'HTML', 'CSS', 'Figma'],
  },
];

export default projectData;
